import React from 'react'
import { ControllerRenderProps, FieldValues, Path } from 'react-hook-form'
import { RadioButton } from '@/components/atoms/radio-button'
import { css, CSSObject, SerializedStyles } from '@emotion/core'
import { FrontTabletFontSize } from '@/constants/front-tablet-typography'
import { createSelfCheckinResponsiveStyle, FrontTabletResponsiveToken } from '@/utils/front-tablet-responsive-style'

type ComponentProps<T extends FieldValues, K extends Path<T>> = {
  id: string
  label?: string
  formValue: string | number | undefined
  className?: string
  radioSizeType: 'normal' | 'small'
  radioLabelSizeType: 'normal' | 'small'
  itemCss?: CSSObject | SerializedStyles
  disabled?: boolean
} & Pick<ControllerRenderProps<T, K>, 'name' | 'onChange' | 'value'>

export const FrontTabletRadioButton = <T extends FieldValues, K extends Path<T>>(props: ComponentProps<T, K>) => {
  return (
    <RadioButton
      id={props.id}
      item={{ value: props.value, label: props.label || '' }}
      checked={props.value === props.formValue}
      name={props.name}
      onChange={props.onChange}
      disabled={props.disabled}
      style={{
        radioSize: props.radioSizeType === 'small' ? FrontTabletFontSize.radioMini : FrontTabletFontSize.radio,
        labelMargin: props.radioSizeType === 'small' ? 16 : 24,
      }}
      itemCss={css(
        props.itemCss,
        {
          label: {
            fontWeight: 500,
            fontSize: props.radioLabelSizeType === 'small' ? FrontTabletFontSize.radioMiniLabel : FrontTabletFontSize.radioLabel,
            letterSpacing: '1px',
          },
        },
        createSelfCheckinResponsiveStyle({
          landscape13: {
            label: {
              fontSize:
                props.radioLabelSizeType === 'small'
                  ? FrontTabletResponsiveToken.formLabelFontSize.landscape13
                  : FrontTabletResponsiveToken.formInputFontSize.landscape13,
              letterSpacing: '1.2px',
            },
          },
        }),
      )}
    />
  )
}
